<div class="overlay-loader"></div>
<img alt="loader" class="loader-icon"/>